<template>
  <div>
    <div class="page bg-green font flex-column bg-init h-100 oh">
      <div class="banner mt-4 bg-init br-16 b-01 flex-end flex-items">
        <a href="#" class="rl mr-5" @click="toNewPage(1)"> User Agreement </a>
        <a href="#" class="rl mr-5" @click="toNewPage(2)">Privacy Policy</a>
      </div>
      <div class="title mt-15">
        Lightweight Interface | Zero-Pressure Interaction | Intelligent Life
        Rhythm
      </div>
      <div class="tips mt-1">
        With a light touch, experience an effortlessly smooth operation like
        flowing clouds and running water.
      </div>
      <div class="mt-8 flex-center">
        <div class="btn-apple flex-center">
          <img src="@/assets/images/apple@2x.png" alt="" />
          <span>Apple download</span>
        </div>
        <div class="btn-google flex-center">
          <img src="@/assets/images/google@2x.png" alt="" />
          <span>Android download</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "",
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    toNewPage(params) {
      if (params == 1) {
        // this.$router.push({ path: "/UserAgreement" });
        window.location.href = "http://www.ailetter.click/TermsofService.html";
      } else {
        // this.$router.push({ path: "/PrivacyPolicy" });
        window.location.href = "http://www.ailetter.click/PrivacyPolicy.html";
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  deactivated() {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
@import "@/assets/styles/base.scss";
.page {
  background-image: url("@/assets/images/bg.png");

  .banner {
    min-width: 140rem;
    height: 5.6rem;
    background-image: url("@/assets/images/header@2x.png");
    .rl {
      font-weight: 350;
      font-size: 1.2rem;
      color: #ffffff;
      line-height: 1.7rem;
      text-align: left;
    }
  }
  .title {
    height: 4.8rem;

    font-family: Source Han Sans, Source Han Sans;
    font-weight: 900;
    font-size: 3.3rem;
    color: #222222;
    line-height: 4.8rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .tips {
    height: 2.6rem;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 1.8rem;
    color: #222222;
    line-height: 2.6rem;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .btn-apple,
  .btn-google {
    width: 16rem;
    height: 4.4rem;
    padding: 1.4rem;
    margin: 0 1.5rem;
    border-radius: 1.2rem 1.2rem 1.2rem 1.2rem;
    img {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 1rem;
    }
    span {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 500;
      font-size: 1.2rem;
      line-height: 1.6rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      white-space: nowrap;
    }
  }
  .btn-apple {
    background: #222222;
    span {
      color: #ffffff;
    }
  }
  .btn-google {
    background: #f6f6f8;
    border: 0.1rem solid #222222;
    span {
      color: #222222;
    }
  }
}
</style>
